export default __webpack_public_path__ + "static/media/home-preview-digital-store.664045dd.jpg";